// IconTips.jsx

import React from "react";

const IconTips = () => {
  return (
    <div className="lg:max-w-2xl rounded-xl border border-violet-500/30 bg-gradient-to-br from-slate-900 via-slate-900 to-violet-950/40 p-4 shadow-xl text-slate-200">
      <div className="flex items-center gap-2 mb-3">
        <span className="text-sm lg:text-xl animate-pulse">👀</span>
        <h3 className="text-sm font-bold text-violet-300">
          Hey...Oye...Psst...ज़रा सुनो...嘿...ねぇ...بالمناسبة <span className="text-pink-400">✨</span>
        </h3>
      </div>

      <div className="space-y-3 text-xs leading-6">

        <p className="rounded-lg border border-violet-500/10 bg-white/5 px-3 py-2 text-xs lg:text-sm text-gray-100">
          🧩 Those tiny icons aren't decoration — most of them are{" "}
          <strong className="text-yellow-300">mini guides!</strong>{" "}
          Tap one anytime and get a quick tip, shortcut, or plain-English
          explanation of what's on screen.{" "}
          <span className="text-cyan-300">💬</span>
        </p>

        <p className="rounded-lg border border-emerald-500/10 bg-white/5 px-3 py-2 text-xs lg:text-sm text-gray-100">
          🌍 We've kept <strong className="text-violet-300">Think5Whys</strong>{" "}
          mostly <strong className="text-emerald-300">self-served</strong> on
          purpose — it's priced to be affordable for every hand holding a
          smartphone, anywhere in the world.{" "}
          <span className="text-yellow-300">📱</span> No steep learning curve,
          no steep price tag.{" "}
          <span className="text-green-300">💸</span>
        </p>

        <p className="rounded-lg border border-cyan-500/10 bg-white/5 px-3 py-2 text-xs lg:text-sm text-gray-100">
          🤝 Once you're a subscriber, you're never on your own though — our{" "}
          <strong className="text-cyan-300">
            Digital Directors and Coordinators
          </strong>{" "}
          are just a message away for real handholding and guidance whenever
          you want a human in the loop.{" "}
          <span className="text-pink-400">❤️</span>
        </p>

        <p className="rounded-lg border border-pink-500/10 bg-white/5 px-3 py-2 text-xs lg:text-sm text-gray-100">
          🚀 <strong className="text-violet-300">Think5Whys</strong> &{" "}
          <strong className="text-pink-300">PurpleDoor</strong> evolve
          continuously to support your daily growth journey, and your
          feedback helps shape what's next.{" "}
          <span className="text-pink-400">💜✨</span>
        </p>

      </div>

      <div className="mt-4 flex items-center gap-2 rounded-lg border border-violet-500/30 bg-gradient-to-r from-violet-500/15 to-pink-500/15 px-3 py-2 text-[11px] text-violet-200">
        <span className="text-base">💡</span>

        <span className="text-xs lg:text-sm text-gray-100">
          <span className="text-cyan-300">🧭 Explore solo</span>
          <span className="mx-2 text-violet-400">•</span>
          <span className="text-pink-300">🙋 Ask for help anytime</span>
        </span>
      </div>
    </div>
  );
};

export default IconTips;